import { Box } from "@dladio/core-ui";
import { Spinner } from "@fluentui/react";

const Loading = () => {
    return (
        <Box>
            <div className={'h-[200px] flex flex-col justify-center'}>
                <Spinner label="Loading..."/>
            </div>
        </Box>
    )
}

export default Loading